// User: Actions for getting vehicle registration information on all vehicle types supported.
import { Dispatch } from 'redux';

import { post, RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { ResponseWithError } from '../generated-types';
import { AppState } from '../reducers';
import { customFailed } from '../util/common';
import { formCalculatorVehicleInfo, FormTypeCalculatorVehicleInfo } from './forms';
import { getRequestHeaders } from './tools';
import { actionTypes, AppActions } from './types';

type Action<T> = import('./types').Action<T>;
// type FetchVehicleInfoRequest = import('../generated-types').VehicleDetailsWebRequest;
type FetchVehicleInfoResponse = import('../generated-types').VehicleDetailsWebResponse;

export interface FetchVehicleInfoStartedAction extends Action<typeof actionTypes.FETCH_VEHICLE_INFO_STARTED> {
    type: typeof actionTypes.FETCH_VEHICLE_INFO_STARTED;
}

export interface FetchVehicleInfoFulfilledAction extends Action<typeof actionTypes.FETCH_VEHICLE_INFO_FULFILLED> {
    type: typeof actionTypes.FETCH_VEHICLE_INFO_FULFILLED;
    payload?: FetchVehicleInfoResponse;
}

export interface FetchVehicleInfoFailedAction extends Action<typeof actionTypes.FETCH_VEHICLE_INFO_FAILED> {
    type: typeof actionTypes.FETCH_VEHICLE_INFO_FAILED;
    payload: RequestExceptionWithResponse;
}

export type VehicleActions =
    | FetchVehicleInfoStartedAction
    | FetchVehicleInfoFulfilledAction
    | FetchVehicleInfoFailedAction;

export const fetchVehicleInfoStarted = (): FetchVehicleInfoStartedAction => ({
    type: actionTypes.FETCH_VEHICLE_INFO_STARTED,
});
export const fetchVehicleInfoFulfilled = (json?: FetchVehicleInfoResponse): FetchVehicleInfoFulfilledAction => ({
    type: actionTypes.FETCH_VEHICLE_INFO_FULFILLED,
    payload: json,
});
export const fetchVehicleInfoFailed = (error: RequestExceptionWithResponse): FetchVehicleInfoFailedAction => ({
    type: actionTypes.FETCH_VEHICLE_INFO_FAILED,
    payload: error,
});

export const fetchVehicleInfo =
    (form: FormTypeCalculatorVehicleInfo) =>
    async (dispatch: Dispatch<AppActions>, getState: () => AppState): Promise<void> => {
        const { loader, context } = getState();
        const { vehicleRegistrationNumber, odometerValue } = form;
        const { isFetchingVehicleInfo } = loader;

        const data = {
            vehicleRegistrationNumber,
            odometerValue: odometerValue !== null ? odometerValue : null,
        };

        if (!isFetchingVehicleInfo) {
            try {
                dispatch(fetchVehicleInfoStarted());
                const response: ResponseWithError<FetchVehicleInfoResponse> = await post(
                    `${actionTypes.RESOURCE_PATH}/vehicle/details`,
                    data,
                    getRequestHeaders(context.config.bankregnr),
                );
                if (response.failure) dispatch(fetchVehicleInfoFailed(customFailed(response.errorOrNull || '')));
                else {
                    dispatch(fetchVehicleInfoFulfilled(response.responseOrNull || undefined));
                    dispatch(formCalculatorVehicleInfo(form));
                }
            } catch (error) {
                dispatch(fetchVehicleInfoFailed(error));
            }
        }
    };
